import { getFormattedPrice } from 'www/utils'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'
import i18next from 'i18next'

function getPriceLabel(price: Filters['price']) {
  const options = { ns: i18next.language }

  const priceToText = i18next.t('До', options)
  const priceFromText = i18next.t('От', options)

  if (price.from !== undefined && price.to !== undefined) {
    if (price.from === 0 && price.to === 0) {
      return getFormattedPrice(price.from) || ''
    }

    const priceForm = getFormattedPrice(price.from, {
      textForZero: false,
      postfix: '',
    })
    const priceTo = getFormattedPrice(price.to, {
      textForZero: false,
    })

    if (price.from === price.to) {
      return priceTo || ''
    }

    if (price.from === 0) {
      return `${priceToText} ${priceTo}`
    }

    if (price.to === 0) {
      return `${priceFromText} ${priceForm}`
    }

    return `${priceFromText} ${priceForm} ${priceToText.toLowerCase()} ${priceTo}`
  }

  if (price.from !== undefined) {
    return getFormattedPrice(price.from, { prefix: priceFromText }) || ''
  }

  if (price.to !== undefined) {
    return getFormattedPrice(price.to, {
      prefix: price.to === 0 ? undefined : priceToText,
      textForZero: i18next.t('Бесплатно', options),
    }) || ''
  }

  return ''
}

export default getPriceLabel
